import axios from 'axios';

export const getTerminalContainersApi = async (terminal_id) => {
	return await axios.get(`/api/containers/?terminal_id=${terminal_id}`);
};
